import React, { useState } from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from "./Components/Home";
import NavBar from './Components/NavBar';
import SideBar from "./Components/SideBar";
import Sourcecode from "./Components/Sourcecode";
import { sourceCodeList } from "./config/constant";
function App() {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => {
    setSidebar(!sidebar);
  };
  return (
    <>
      <Router basename="/">
        <NavBar showSidebar={showSidebar} />
        <div className="row">
          {sidebar && (
            <div className="col-2">
              <SideBar />
            </div>
          )}
          <div className={`col-${sidebar
            ? "10"
            : "12"
            }`}>
            <Switch>
              {sourceCodeList.map((elements, index) => {
                return (
                  elements.type ? (

                    elements.subs.map((element, indexs) =>
                      <Route path={element.path}>
                        <Sourcecode element={element} key={indexs} />
                      </Route>

                    )

                  ) : (
                    <Route path={elements.path}>
                      <Sourcecode element={elements} key={index} />
                    </Route>
                  ))
              })}
              <Route exact path="/">
                <Home />
              </Route>
            </Switch>
          </div>
        </div>

      </Router>

    </>
  );
}

export default App;
